import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ChatHistoryGetRequest,
  ChatHistoryGetResponse,
  ChatHistoryListRequest,
  ChatHistoryListResponse,
} from '../components/ai-usage/models/chat-history-usage.model';

@Injectable({ providedIn: 'root' })
export class ChatHistoryUsageService {
  private readonly listUrl = `${environment.apiBaseUrl}/api/chat-history/usage/list`;
  private readonly getByIdUrl = `${environment.apiBaseUrl}/api/chat-history/usage/get-by-id`;

  constructor(private readonly http: HttpClient) {}

  listUsage(body: ChatHistoryListRequest): Observable<ChatHistoryListResponse> {
    return this.http.post<ChatHistoryListResponse>(this.listUrl, body);
  }

  getConversation(body: ChatHistoryGetRequest): Observable<ChatHistoryGetResponse> {
    return this.http.post<ChatHistoryGetResponse>(this.getByIdUrl, body);
  }
}
